export default __webpack_public_path__ + "svg/CompaniesLogos/logo_roundcubers.svg?b38efaa4";